import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import Field from '../Field.js';
import withFormArray$1 from '../../../cinnamon-core/es/components/forms/withFormArray.js';
import VirtualizedList$1 from '../../../cinnamon-web/es/components/utility/VirtualizedList.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import { fieldErrors, prettifyField } from '../../../cinnamon-core/es/components/forms/utils.js';

var componentRoot = createComponentSlot({
  name: "CinFormArray",
  slot: "Root"
});

var ArrayFieldBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayFieldBase, _React$Component);

  var _super = _createSuper(ArrayFieldBase);

  function ArrayFieldBase() {
    var _this;

    _classCallCheck(this, ArrayFieldBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderVirtualizedItems", function (start, end) {
      var _this$props = _this.props,
          value = _this$props.value,
          renderItem = _this$props.renderItem;
      var items = value.slice(start, end);
      return items.map(function (v, index) {
        return renderItem(v, start + index);
      });
    });

    return _this;
  }

  _createClass(ArrayFieldBase, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          label = _this$props2.label,
          labelProps = _this$props2.labelProps,
          minLength = _this$props2.minLength,
          showErrors = _this$props2.showErrors,
          allErrors = _this$props2.allErrors,
          animateErrors = _this$props2.animateErrors,
          disabled = _this$props2.disabled,
          errors = _this$props2.errors,
          children = _this$props2.children,
          className = _this$props2.className,
          virtualized = _this$props2.virtualized,
          virtualizationOptions = _this$props2.virtualizationOptions;
      return /*#__PURE__*/React.createElement(Field, {
        required: !!minLength,
        disabled: disabled,
        width: null,
        label: label,
        labelProps: labelProps,
        errors: fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors,
        className: classnames(componentRoot.className, className)
      }, virtualized ? /*#__PURE__*/React.createElement(VirtualizedList$1, _extends({}, virtualizationOptions, {
        totalItems: value.length,
        renderItems: this.renderVirtualizedItems
      })) : children);
    }
  }]);

  return ArrayFieldBase;
}(React.Component);

_defineProperty(ArrayFieldBase, "propTypes", {
  label: propTypes.node,
  labelProps: propTypes.any,
  virtualizationOptions: propTypes.any,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any,
  minLength: propTypes.number,
  minLengthError: propTypes.string,
  maxLength: propTypes.number,
  maxLengthError: propTypes.string,
  field: propTypes.string.isRequired,
  arrayKey: propTypes.string,
  showErrors: propTypes.bool,
  allErrors: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  disabled: propTypes.bool,
  readOnly: propTypes.bool,
  autoAdd: propTypes.bool,
  autoAddPopulate: propTypes.func,
  autoRemove: propTypes.bool,
  propagateUpdates: propTypes.any,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  virtualized: propTypes.bool
});

_defineProperty(ArrayFieldBase, "defaultProps", {
  arrayKey: "key",
  autoAdd: false,
  autoAddPopulate: function autoAddPopulate(arrayKey) {
    return _defineProperty({}, arrayKey, Date.now());
  },
  autoRemove: false
});

var ConnectedArrayField = withFormArray$1({
  defaultProps: {
    arrayKey: "key",
    autoAdd: false,
    autoAddPopulate: function autoAddPopulate(arrayKey) {
      return _defineProperty({}, arrayKey, Date.now());
    },
    autoRemove: false
  },
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : prettifyField(props.field);
  }
})(ArrayFieldBase);
var ArrayFieldRoot = styled(ConnectedArrayField, componentRoot.styledOptions)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    "> .CinForm-label:first-of-type": {
      marginBottom: theme.spacing(1.25)
    },
    // collapse the bottom margin of last field
    "> .CinForm-field + .CinForm-errors:last-child": {
      marginTop: theme.spacing(-3),
      ".CinForm-error:first-of-type": {
        marginTop: theme.spacing(1)
      }
    }
  };
});
/**
 * Nests child form field data within an array of objects
 */

var ArrayField = function ArrayField(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(ArrayFieldRoot, rootProps);
};

var ArrayField$1 = ArrayField;

export { ArrayField$1 as default };
